import React from "react";
import { useOutletContext } from "react-router-dom";

import ProductionsTableView from "../views/ProductionsTableView/ProductionsTableView";

export default function ProductionsTable() {
	const { data, organization } = useOutletContext();

	return <ProductionsTableView organization={organization} data={data} />;
}
